<div
  class="rounded-lg overflow-hidden shadow-md bg-surface dark:bg-surface-darkmode border border-outline dark:border-outline-darkmode text-on-surface dark:text-on-surface-darkmode py-[3px]"
>
  <ng-content />
</div>
